<!--QRCode: 生成带图片的二维码 2020/07/14 17:45:57 Sunanguang-->

<template>
  <!-- 生成二维码开放接口:
       二维码内容[通常为url]
       二维码大小[限制为正方形]
       二维码中间显示：文字或LOGO[默认不显示]-->
  <div id="meQrcode">
    <div class="qrcode_box">
      <img v-if="qrLogo" class="qrcode_logo" ref="qrcode_logo" :src="qrLogo" alt="二维码logo">
      <div :style="{width:qrSize+'px',height:qrSize+'px'}" :id="'qrcode_canvas_'+qrcodeId" class="canvas" ref="canvas"></div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
export default {
  data () {
    return {
      qrcode: ''
    }
  },
  /** 传入时间戳显示倒计时函数【后台时间戳一般都是10位的】
         * @argument qrUrl        二维码内容
         * @argument qrSize       二维码大小
         * @argument qrText       二维码中间显示文字
         * @argument qrTextSize   二维码中间显示文字大小(默认16px)
         * @argument qrLogo       二维码中间显示图片
         * @argument qrLogoSize   二维码中间显示图片大小(默认为80)
         * 注：qrText与qrLogo只能显示一个，如果想要显示两个需要自行设计
         */
  props: ['qrUrl', 'qrSize', 'qrText', 'qrLogo', 'qrLogoSize', 'qrTextSize', 'qrcodeId'],
  mounted () {
    this.drawQR()
  },
  methods: {
    drawQR () {
      // 画二维码里的logo[注意添加logo图片的时候需要使用服务器]
      let qrcode_canvas = this.$refs.qrcode_canvas
      let qrcode_logo = this.$refs.qrcode_logo
      let canvas = this.$refs.canvas
      let id = 'qrcode_canvas_' + this.qrcodeId
      document.getElementById(id).innerHTML = ''
      this.qrcode = new QRCode(document.getElementById(id), {
          text: this.qrUrl,
          width: this.qrSize,
          height: this.qrSize,
          colorDark : "#000000",
          colorLight : "#ffffff",
          correctLevel : QRCode.CorrectLevel.H
      })
      this.$nextTick(()=>{
        document.getElementById(id).setAttribute('title','')
      })
    }
  },
  watch: {
    qrUrl () {
      this.drawQR()
    }
  }
}
</script>
<style scoped>
.qrcode_box,#meQrcode{
  display: inline-block
}
.qrcode_box {
  /* padding: 10px; */
  /* border: 1px solid #DCDCDC; */
  position: relative;
}
.qrcode_box img {
  width: 30px !important;
  height: 30px !important;
  position: absolute;
  top: 50%;
  margin-top: -15px !important;
  left: 50%;
  margin-left:  -15px !important;
  border: 1px solid #99999938;
}
.qrcode_canvas >>> img{
  width: 115px;
  height: 115px;
}
.qrcode_box >>> canvas {
  display: block !important;
  width: 115px;
  height: 115px;
}
.qrcode_box >>> img {
  display: none !important;
}
</style>
